import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';

import { toggleCollapsedNav, updateWindowWidth } from 'actions/Setting';
import SideBarOptions from 'components/molecules/SideBarOptions';
import UserInfo from 'components/molecules/UserInfo';
import { COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION } from 'constants/ActionTypes';

import SideBarContent from './SideBarContent';

const SIDEBAR_BREAKPOINT = 1200;

const SideBar = () => {
  const dispatch = useDispatch();
  const { navCollapsed, drawerType, width, navigationStyle } = useSelector(({ settings }) => settings);

  useEffect(() => {
    let timeoutId = null;
    const handleResize = () => {
      // Debounce: espera que el usuario termine de redimensionar
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        dispatch(updateWindowWidth(window.innerWidth));
      }, 150);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [dispatch]);

  const onToggleCollapsedNav = (e) => {
    dispatch(toggleCollapsedNav());
  };

  let type = 'permanent';
  let drawerStyle = drawerType.includes(FIXED_DRAWER)
    ? 'd-xl-flex'
    : drawerType.includes(COLLAPSED_DRAWER)
    ? ''
    : 'd-flex';
  if (drawerType.includes(COLLAPSED_DRAWER) || (drawerType.includes(FIXED_DRAWER) && width < SIDEBAR_BREAKPOINT)) {
    type = 'temporary';
  }

  if (navigationStyle === HORIZONTAL_NAVIGATION) {
    drawerStyle = '';
    type = 'temporary';
  }

  return (
    <div className={`app-sidebar d-none ${drawerStyle}`}>
      <Drawer
        className="app-sidebar-content"
        variant={type}
        open={type.includes('temporary') ? navCollapsed : true}
        onClose={onToggleCollapsedNav}
        classes={{
          paper: 'side-nav',
        }}
      >
        <UserInfo />
        <SideBarContent />
        <SideBarOptions />
      </Drawer>
    </div>
  );
};

export default withRouter(SideBar);
